import Layout from '../../components/feature/Layout';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import AdvantagesSection from './components/AdvantagesSection';
import ProductsSection from './components/ProductsSection';
import NewsSection from './components/NewsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <StatsBar />
      <AboutSection />
      <ServicesSection />
      <AdvantagesSection />
      <ProductsSection />
      <NewsSection />
      <CTASection />
    </Layout>
  );
}
